import React from 'react';

export const NotFoundPage = props => {

    return (
        <div>Not found 404</div>
    );
}
